// extracted by mini-css-extract-plugin
export default {"button":"SupportWidgetButton_button__nkpmi"};